import styled from "styled-components";

const MenuIconWrapper = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 6px;
  margin-left: -4px;
  color: ${({ theme }) => theme.textSecondary};
`;

export default MenuIconWrapper;
